import useDefaultBuilderSchemaId from './useDefaultBuilderSchemaId';
import { useQuery } from '@apollo/client';
import {
  IFormulaConfigQuery,
  IFormulaConfigQueryVariables,
  WeekStart,
} from '../../../utils/apollo/graphqlSchema';
import initialFormulaConfigQuery from '../apollo/initialFormulaConfigQuery';
import moment from 'moment/moment';

const useFormulaConfigWeekStartEffect = () => {
  const defaultBuilderSchemaId = useDefaultBuilderSchemaId();

  const { loading } = useQuery<
    IFormulaConfigQuery,
    IFormulaConfigQueryVariables
  >(initialFormulaConfigQuery, {
    variables: {
      schemaId: defaultBuilderSchemaId,
    },
    onCompleted: ({ formulaConfig }) => {
      // set the beginning of week based on the customer's weekStart of SUNDAY or MONDAY
      const dow = formulaConfig.weekStart === WeekStart.Sunday ? 0 : 1;
      moment.updateLocale('en', {
        week: {
          dow,
        },
      });
    },
  });
  return { loading };
};

export default useFormulaConfigWeekStartEffect;
